import { render, staticRenderFns } from "./workcenter-final-test.vue?vue&type=template&id=677bde73&"
import script from "./js/workcenter-final-test.js?vue&type=script&lang=js&"
export * from "./js/workcenter-final-test.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports